module.exports = __webpack_public_path__ + "static/media/party-can.2eef974d.png";